import API from './API'

export default class User extends API {
    static forgotPW(email: string) {
        return API.baseRequest("POST", "forgot_password/", {
            email: email,
        })
    }
}